<template>
    <div class="service">
        <section class="page-banner"></section>

        <article class="mainwrap">
            <div class="maincon">
                <section class="skin-1">
                    <h1 class="custom-headline">
                        <span class="custom-headline-inner">Services</span>
                    </h1>

                    <div class="anchors flex-wrap-between">
                        <div class="anchors-item">
                            <div class="anchors-head flex-middle">
                                <i class="font-icon icon-accelerate"></i>
                                <span>Accelerate</span>
                            </div>

                            <ul class="anchors-list">
                                <li @click="scrollGo('customer')">Customer Experience</li>
                                <li @click="scrollGo('cc')">Contact Centre</li>
                                <li @click="scrollGo('strategy')">Strategy Design & Implementation</li>
                            </ul>
                        </div>
                        <div class="anchors-item">
                            <div class="anchors-head flex-middle">
                                <i class="font-icon icon-optimise"></i>
                                <span>Optimise</span>
                            </div>

                            <ul class="anchors-list">
                                <li @click="scrollGo('mapping')">Business Process Mapping & Reengineering</li>
                                <li @click="scrollGo('blockchain')">Blockchain</li>
                                <li @click="scrollGo('ai')">Artificial Intelligence</li>
                            </ul>
                        </div>
                        <div class="anchors-item">
                            <div class="anchors-head flex-middle">
                                <i class="font-icon icon-transform"></i>
                                <span>Transform</span>
                            </div>

                            <ul class="anchors-list">
                                <li @click="scrollGo('digital')">Digital Transformation</li>
                                <li @click="scrollGo('transition')">Business Transformation</li>
                            </ul>
                        </div>
                    </div>

                    <div class="line"></div>
                </section>

                <section class="skin-2">
                    <h3 class="h3">Our Asia based consulting&nbsp; services are <strong>fully customised</strong>&nbsp; to suit your specific requirements for <strong>accelerating&nbsp;growth and optimising costs</strong>.</h3>
                    <p class="info-txt">Delta Consulting Services offers the full suite of consulting services to accelerate your plans for growth, cost optimisation, and business transformation. We specialise in creating brand value and implementing practical strategies that achieve real and sustainable results. Our domain area expertise is in Customer Experience, Strategy, Business Transformation, and Operational Excellence. Our specialised service offering is customised for each client based on their circumstances. Whether its strategy design, roadmap creation, or full digital transformation, we are well resourced to implement the most effective solution to differentiate your organisation in the marketplace.</p>
                    <h4 class="h4">Asia&nbsp; business consulting services to redefine your future business performance.</h4>
                    <h3 class="h3"><strong>Get in touch with our team today to see how we can help you.</strong></h3>
                </section>

                <ul class="skin-3 flex-wrap-between-top">
                    <li class="list-item">
                        <a class="anchor" id="customer"></a>
                        <div class="imgwrap" :style="{height: imgHeight}">
                            <picture>
                                <source type="image/webp" srcset="//growth-s3.s3.ap-southeast-1.amazonaws.com/service/item-1.webp">
                                <img src="//growth-s3.s3.ap-southeast-1.amazonaws.com/service/item-1.jpg">
                            </picture>
                        </div>
                        <div class="conwrap">
                            <h4 class="h4">Customer Experience for Growth</h4>
                            <p class="info-txt">Our team is comprised of leading international professionals who have a proven reputation for creating customer experience solutions that allow clients to sustainably increase the economic value of their company. We do this by working with you to transform your organisation via our unique methodology, allowing you and your business to begin achieving your goals as quickly and effectively as possible. As one of the leading consulting companies in Asia, we have the expertise and skill needed to design and integrate solutions that are not only practical for your employees and your business, but effective at generating sustainable economic value.</p>
                        </div>
                    </li>
                    <li class="list-item">
                        <a class="anchor" id="cc"></a>
                        <div class="imgwrap" :style="{height: imgHeight}">
                            <picture>
                                <source type="image/webp" srcset="//growth-s3.s3.ap-southeast-1.amazonaws.com/service/item-2.webp">
                                <img src="//growth-s3.s3.ap-southeast-1.amazonaws.com/service/item-2.jpg">
                            </picture>
                        </div>
                        <div class="conwrap">
                            <h4 class="h4">Contact Centre Design for Excellence</h4>
                            <p class="info-txt">The contact centre is often the key customer management function in most organisations. The changing customer requirements for corporate interaction across multiple different channels requires designs that incorporate leading omni-channel technology. Our expertise in designing contact centres spans over 25 years’ experience and is backed by our track record for winning awards. Enquire how we can help design a world class contact centre that incorporates all the best practices for a fully optimised operation. </p>
                        </div>
                    </li>
                    <li class="list-item">
                        <a class="anchor" id="strategy"></a>
                        <div class="imgwrap" :style="{height: imgHeight}">
                            <picture>
                                <source type="image/webp" srcset="//growth-s3.s3.ap-southeast-1.amazonaws.com/service/item-3.webp">
                                <img src="//growth-s3.s3.ap-southeast-1.amazonaws.com/service/item-3.jpg">
                            </picture>
                        </div>
                        <div class="conwrap">
                            <h4 class="h4">Strategy Design & Implementation for Growth</h4>
                            <p class="info-txt">Designing a corporate strategy and implementing it to ensure business goals are achieved for the shareholders is often a difficult and complex task. Our expertise as strategy consultants is based on over 25 years of experience working with a diverse range of industries across the globe. Leveraging of our expertise will help you minimise any humps in your plans and accelerate the outcomes from your strategy.</p>
                        </div>
                    </li>
                    <li class="list-item">
                        <a class="anchor" id="mapping"></a>
                        <div class="imgwrap" :style="{height: imgHeight}">
                            <picture>
                                <source type="image/webp" srcset="//growth-s3.s3.ap-southeast-1.amazonaws.com/service/item-4.webp">
                                <img src="//growth-s3.s3.ap-southeast-1.amazonaws.com/service/item-4.jpg">
                            </picture>
                        </div>
                        <div class="conwrap">
                            <h4 class="h4">Business Process Mapping & Reengineering</h4>
                            <div class="info-txt">
                                <span>The very foundation of any great customer experience is consistency. The fabric of consistency is your Standard Operating Procedures (SOPs) and</span>
                                <span class="link" @click="$router.push({name: 'business'})">processes</span>
                                <span>. Many organisations have neglected their SOPs as a possible root- cause problem to the unhappiness created for their customers. Our management consultancy services and expertise in customer experience has enabled us to reengineer and streamline processes and procedures for Fortune 500 companies on a global basis. The result has seen a major uplift in customer satisfaction and corporate profitability.</span>
                            </div>
                        </div>
                    </li>
                    <li class="list-item">
                        <a class="anchor" id="transition"></a>
                        <div class="imgwrap" :style="{height: imgHeight}">
                            <picture>
                                <source type="image/webp" srcset="//growth-s3.s3.ap-southeast-1.amazonaws.com/service/item-5.webp">
                                <img src="//growth-s3.s3.ap-southeast-1.amazonaws.com/service/item-5.jpg">
                            </picture>
                        </div>
                        <div class="conwrap">
                            <h4 class="h4">Business Transformation</h4>
                            <p class="info-txt">Whether you are merging with another company, acquiring a new one, or changing your operations to accelerate growth, Delta Consulting Services is able to facilitate the transformation required in your organisation. Our management consultants work with all stakeholders to ensure all aspects of your business transform effectively to new operating models and are able to extract new value for your customers.</p>
                        </div>
                    </li>
                    <li class="list-item">
                        <a class="anchor" id="digital"></a>
                        <div class="imgwrap" :style="{height: imgHeight}">
                            <picture>
                                <source type="image/webp" srcset="//growth-s3.s3.ap-southeast-1.amazonaws.com/service/item-6.webp">
                                <img src="//growth-s3.s3.ap-southeast-1.amazonaws.com/service/item-6.jpg">
                            </picture>
                        </div>
                        <div class="conwrap">
                            <h4 class="h4">Digital Transformation</h4>
                            <div class="info-txt">
                                <span>The age of the hyper-connected consumer has arrived. With simply the click of a button consumers can immerse themselves in a world of products and services that span the millions. This makes switching brands as simple as ever and gives them the freedom to write negative reviews at any point, a feature that can severely impact your success. Our management consultancy helps you create a value based digital transformation that will encourage positive interactions between</span>
                                <span class="link" @click="$router.push({name: 'experience'})">customers and your company</span>
                                <span>. Now more than ever, the success of a company lies in its ability to reduce effort and increase convenience for customers using digital solutions.</span>
                            </div>
                        </div>
                    </li>
                    <li class="list-item">
                        <a class="anchor" id="blockchain"></a>
                        <div class="imgwrap" :style="{height: imgHeight}">
                            <picture>
                                <source type="image/webp" srcset="//growth-s3.s3.ap-southeast-1.amazonaws.com/service/item-7.webp">
                                <img src="//growth-s3.s3.ap-southeast-1.amazonaws.com/service/item-7.jpg">
                            </picture>
                        </div>
                        <div class="conwrap">
                            <h4 class="h4">Blockchain to Optimise Customer Experiences</h4>
                            <p class="info-txt">The transfer of digital assets using a highly secured system for identity verification is the underlying foundation of blockchain technology. This technology has a profound impact on how many organisations currently conduct transactions that require verification. Blockchain solutions offer the organisation a new way to reduce costs and improve services to their end customers. Our joint venture with the blockchain accelerator, RedFox Labs, enables us to also deliver blockchain solutions most effectively and efficiently.</p>
                        </div>
                    </li>
                    <li class="list-item">
                        <a class="anchor" id="ai"></a>
                        <div class="imgwrap" :style="{height: imgHeight}">
                            <picture>
                                <source type="image/webp" srcset="//growth-s3.s3.ap-southeast-1.amazonaws.com/service/item-8.webp">
                                <img src="//growth-s3.s3.ap-southeast-1.amazonaws.com/service/item-8.jpg">
                            </picture>
                        </div>
                        <div class="conwrap">
                            <h4 class="h4">Artificial Intelligence for Optimising Business</h4>
                            <p class="info-txt">The journey of Artificial Intelligence will vary for each organisation. At the most basic level, robotic process automation offers many organisations a low-risk way to quantify the value of introducing artificial intelligence into their work practices. Whether it’s your marketing, sales or operations area, artificial intelligence can unlock new value and deliver improved performance for both the organisation and the end customer.</p>
                        </div>
                    </li>
                </ul>
            </div>
        </article>
    </div>
</template>

<script>
export default {
    name: 'Service',
    inject: ['APP'],
    data(){
        return {
            allAnchor: null, //所有锚点dom 对象
            topsObj: {}, //top值对象
            topsArray: [], //top值数组
            imgHeight: 'auto', //img高度
            isScroll: false
        }
    },
    computed: {
        routeHash(){
            return this.$route.hash;
        }
    },
    watch: {
        routeHash: 'scrollGo'
    },
    created(){
        this.getImgHeight();
    },
    mounted(){
        $(()=>{
            this.allAnchor = $('.anchor');
            this.getOffsetTops();

            const {routeHash} = this;
            routeHash && this.scrollGo(routeHash);
        })
    },
    methods: {
        /**图片高度 */
        getImgHeight(){
            const bodyWidth = document.body.clientWidth
            const wrapWidth = Math.min(bodyWidth * 0.88, 1200);
            const itemWidth = wrapWidth * (bodyWidth > 500 ? 0.475 : 1) - 2;
            const imgHeight = itemWidth * 0.6698;
            this.imgHeight = imgHeight + 'px';
        },

        /**获取所有锚点的位置 */
        getOffsetTops(){
            let {allAnchor, topsObj, topsArray} = this;
            const headHeight = document.getElementById('header_wrap').clientHeight;
            allAnchor.map((i, item) => {
                let id = item.getAttribute('id');
                let top = item.offsetTop;
                let height = item.parentElement.clientHeight;
                topsObj[id] = top;
                topsArray.push({
                    id, 
                    top: top - headHeight - 100, 
                    max: top + Math.round(height * 0.7)
                });
            })
        },

        /**根据hash 滚动至指定hash处 */
        scrollGo(hash){
            this.isScroll = true;
            hash = hash.replace('#', '');
            this.scrTo( this.topsObj[hash] - document.getElementById('header_wrap').clientHeight - 10);
        },

        /**窗口改变或滚动时 由APP.vue 中调用 */
        flashWindow(top, isResize){
            if(isResize){
                this.getImgHeight();
                this.$nextTick(()=>{
                    this.getOffsetTops();
                    this.scrollGo( this.routeHash );
                })
            }else{
                this.getHashForTop(top);
            }
        },

        /**根据滚动的top值获取hash */
        getHashForTop(top){
            if(this.isScroll){
                setTimeout(()=>{this.isScroll = false}, 1500);
                return ;
            }
            let array = [].concat(this.topsArray);
            const hashObj = array.find(item => top >= item.top && top <= item.max);
            this.APP.childPageScrollHash = hashObj ? hashObj.id : '';
        },
    }
}
</script>

<style lang="less">
    .service{
        .page-banner{height: 320.59px;background-image: url('//growth-s3.s3.ap-southeast-1.amazonaws.com/service/banner.png');}
        .custom-headline{margin-bottom: 0;}

        .skin-1{
            &{padding: 45px 0;color: #333;}

            .anchors{
                &{padding: 30px 0 23px;}
                .anchors-item{width: calc(33.33% - 30px);font-size: 18px;margin-top: 20px;}
                .anchors-head{line-height: 1.1;letter-spacing: -1px;font-size: 228.5%;}
                .font-icon{width: 54px;height: 54px;background: #333;border-radius: 100px;margin-right: 8px;color: #fff;font-size: 27px;text-align: center;line-height: 54px;flex: none;}
                .icon-accelerate::before{content: "\e027";}
                .icon-optimise::before{content: "\f0eb";}
                .icon-transform::before{content: '\f085';}

                .anchors-list {
                    &{list-style-type: disc;color: #848484;margin: 23px 0 0 27.9px;}
                    li{color: #333;line-height: 1.7;cursor: pointer;}
                }
                @media (max-width: 896px){
                    .anchors-item{width: calc(50% - 10px);}
                }
                @media (max-width: 582px){
                    .anchors-item{width: 100%;}
                }
            }
            .line{border-top: 4px double rgba(0,0,0,0.5);}
        }

        .skin-2{
            .h3{font-size: 37px;}
            .h4{font-size: 30px;}
        }

        .skin-3{
            .list-item{width: 47.5%;}
            .link{cursor: pointer;color: #f15a24;margin: 0 3px;}
            @media (max-width: 500px){
                .list-item{width: 100%;}
            }
        }
    }
</style>